module.exports = __webpack_public_path__ + "img/btn2.1422e187.png";